/**
 * Review aka Testimonial model
 * */

export const REVIEW_TYPE = {
    video: "video",
    text: "text",
};

// Review for (VIEW) purposes e.g. (/reviews/:wallUuid)
export const makeEmptyReview = () => ({
    name: "",
    photo: "",
    authorEmail: "",
    position: "",
    rate: 5,
    type: REVIEW_TYPE.text,
    content: "",
    www: "",
    video: "",
    images: [],
    gifs: [],
});

// Review for Sidebar purposes e.g. (/projects/:wallUuid/review-list)
export const makeEmptyReviewForWall = (wall) => {
    const emptyNew = makeEmptyReview();
    return {
        ...emptyNew,
        uuid: "",
        wallId: wall.id,
        isPublished: wall.publishAutomatically,
        confirmed: false,
    };
};
